var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMinimizeScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82143 2.24071C6.82143 1.74375 7.17154 1.38483 7.65984 1.38483C8.15735 1.38483 8.52588 1.75295 8.52588 2.24071V7.04468C8.52588 7.97419 7.9823 8.50796 7.06098 8.50796H2.22403C1.72651 8.50796 1.34877 8.15825 1.34877 7.66129C1.34877 7.16432 1.72651 6.81461 2.22403 6.81461H2.93345L5.87247 6.98947L3.55073 4.79915L0.924963 2.17629C0.759125 2.00143 0.666992 1.78056 0.666992 1.54128C0.666992 1.01671 1.05395 0.666992 1.5791 0.666992C1.80943 0.666992 2.02134 0.74982 2.17796 0.915474L4.79452 3.54754L6.99648 5.8575L6.82143 2.94014V2.24071Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9489 9.48347H15.7858C16.2834 9.48347 16.6519 9.84239 16.6519 10.3394C16.6519 10.8363 16.2741 11.186 15.7858 11.186H15.0672L12.1282 11.0112L14.4499 13.2015L17.0757 15.8244C17.2415 15.99 17.3337 16.2109 17.3337 16.4594C17.3337 16.9839 16.9467 17.3336 16.4215 17.3336C16.1912 17.3336 15.9885 17.2508 15.8227 17.0852L13.2061 14.4531L11.0042 12.1339L11.1884 15.0605V15.7507C11.1884 16.2477 10.8291 16.6158 10.3408 16.6158C9.8433 16.6158 9.48398 16.2385 9.48398 15.7507V10.9468C9.48398 10.0265 10.0184 9.48347 10.9489 9.48347Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinimizeScreen);
export default __webpack_public_path__ + "static/media/icon-minimize-screen.ca05578c0d45cfa7a0c2c1073434dd32.svg";
export { ForwardRef as ReactComponent };